import React from 'react';
import { Grid } from '../../../../../components/Grid';
import { GridCell } from '../../../../../components/GridCell';
import { convertNumberToString } from '../../../../../utils/formatNumber';
import { formatKm } from '../../../../../utils/mask';

interface Props {
  data: any;
}

export const MotorcycleDatasheet = ({ data }: Props) => {
  const {
    year,
    yearFabrication,
    odometer,
    color,
    motor,
    fuel,
    typeVehicle,
    coolingType,
    matchType,
  } = data;
  const dataSheetLabel = 'f14 fw2 boulder ma0';
  const dataSheetValue = 'f14 fw4 abbey';

  const odometerFormatted = formatKm(convertNumberToString(odometer));

  return (
    <Grid className="flex-column-ns">
      <GridCell width={[1 / 2, 1]} className="flex flex-column flex-row-ns justify-between-ns">
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Ano</p>
          <b className={dataSheetValue}>
            {yearFabrication}/{year}
          </b>
        </GridCell>

        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>KM</p>
          <b className={dataSheetValue}>{odometerFormatted || '--'}</b>
        </GridCell>

        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Cilindradas</p>
          <b className={dataSheetValue}>{convertNumberToString(motor)}</b>
        </GridCell>

        <GridCell width={[1, 1 / 4]} className="pr24">
          <p className={dataSheetLabel}>Combustível</p>
          <b className={dataSheetValue}>{fuel}</b>
        </GridCell>
      </GridCell>
      <GridCell width={[1 / 2, 1]} className="flex flex-column flex-row-ns justify-between-ns">
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Refrigeração</p>
          <b className={dataSheetValue}>{coolingType}</b>
        </GridCell>

        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Partida</p>
          <b className={dataSheetValue}>{matchType}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24">
          <p className={dataSheetLabel}>Tipo</p>
          <b className={dataSheetValue}>{typeVehicle}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Cor</p>
          <b className={dataSheetValue}>{color}</b>
        </GridCell>
      </GridCell>
    </Grid>
  );
};
